import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";

const Schluesselliste = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [ModalTable, setModalTable] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [loading, setLoading] = useState(false);
  const [daten, setDaten] = useState([]);
  const [TableDaten, setTableDaten] = useState([]);
  const [searchfield, setSearchfield] = useState('');
  const [vertrag, setvertrag] = useState('');
  const inputRef = useRef(null);

  // === AUTOLOAD (ALLE SCHLÜSSEL) ===
  const searchh = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        'https://dhworld.dietenmeier-harsch.de/searchSchluessell.php',
        { params: { searchfield }, withCredentials: true }
      );
      setDaten(res.data.daten);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("loginData")) {
      navigate("/dhworld/login");
      return;
    }
    searchh(); // Autoload
  }, []);

  // === MANUELLE SUCHE ===
  const search = async () => {
    if (searchfield.trim() === '') return;
    setLoading(true);
    setModalShow(false);
    try {
      const res = await axios.get(
        'https://dhworld.dietenmeier-harsch.de/searchSchluessel.php',
        { params: { searchfield }, withCredentials: true }
      );
      setDaten(res.data.daten);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const click = async (vertragsnummer) => {
    setvertrag(vertragsnummer);
    try {
      const res = await axios.get(
        'https://dhworld.dietenmeier-harsch.de/searchVertragDetails.php',
        { params: { vertragsnummer }, withCredentials: true }
      );
      setTableDaten(res.data.daten);
      setModalTable(true);
    } catch (err) {
      console.error(err);
    }
  };

  const focusInput = () => {
    inputRef.current?.focus();
  };

  const handleClear = () => {
    setSearchfield('');
    searchh(); // Zurück zu allen
  };

  return (
    <div style={{ backgroundColor: '#eceff2', minHeight: '100vh' }} className="container-fluid">
      <div className="row pt-4">
        <div className='col-12'>

          <Link to="/insight">
            <i style={{ fontSize: '25px' }} className="bi bi-arrow-return-left"></i>
          </Link>
          <br /><br />

          {/* Kopfzeile + Immer sichtbare Lupe */}
          <Row className="mb-3 align-items-center">
            <Col>
              <h3 style={{ fontWeight: 'bold' }}>Schlüsselliste</h3>
            </Col>
            <Col xs="auto">
              <i
                className="bi bi-search"
                style={{ fontSize: '1.5rem', cursor: 'pointer' }}
                onClick={() => setModalShow(true)}
              ></i>
            </Col>
          </Row>

          {/* Suchinfo wenn ein Text existiert */}
          {searchfield.trim() !== '' && (
            <Row style={{
              background: '#fff',
              border: '1px solid #e6e8ed',
              boxShadow: '0 2px 4px #00000012',
              height: '5.2rem',
              marginBottom: '1rem'
            }}>
              <Col xs={1} className="d-flex align-items-center justify-content-center">
                <i className="bi bi-search" style={{ fontSize: '20px', color: '#1245fb' }}></i>
              </Col>
              <Col xs={9} className="d-flex align-items-center">
                Suche: {searchfield}
              </Col>
              <Col xs={2} className="d-flex align-items-center justify-content-center">
                <i
                  className="bi bi-x-lg"
                  style={{ cursor: 'pointer', fontSize: '20px', color: '#1245fb' }}
                  onClick={handleClear}
                ></i>
              </Col>
            </Row>
          )}

          {/* LOADING */}
          {loading ? (
            <Row>
              <Col xs={12} className="text-center">
                <Spinner animation="border" variant="primary" />
              </Col>
            </Row>
          ) : (
            // ERGEBNISSE
            <div>
              <Row className="g-4">
                {daten && daten.length > 0 ? (
                  daten.map((v, index) => (
                    <Col style={{ cursor: 'pointer' }} key={index} md={4}>
                      <div style={{
                        background: '#fff',
                        padding: '1rem',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        height: '100%'
                      }}>
                        <p><strong>Schlüssel/Zugangscode:</strong> {v.GBK_Kuerzel}</p>
                        <p><strong>Gebäude/Info:</strong> {v.GBK_Beschreibung}</p>
                      </div>
                    </Col>
                  ))
                ) : (
                  <Col xs={12}>
                    <div style={{
                      background: '#fff',
                      padding: '1rem',
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      Keine Daten gefunden
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          )}
        </div>
      </div>

      {/* --------------------------------------- */}
      {/* SUCHMODAL */}
      {/* --------------------------------------- */}
      <Modal size="lg" centered show={modalShow} onHide={() => setModalShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Schlüssel suchen</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ paddingBottom: '60px' }}>
          <div
            style={{
              backgroundColor: '#eceff2',
              padding: '20px',
              borderRadius: '8px',
              cursor: 'text',
              borderBottom: inputFocused ? '3px solid #66bfff' : '3px solid #ccc',
              transition: 'border-color 0.3s ease',
            }}
            onClick={focusInput}
          >
            <Form onSubmit={(e) => { e.preventDefault(); search(); }}>
              <Form.Group>
                <Form.Control
                  ref={inputRef}
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                  style={{
                    backgroundColor: 'transparent',
                    fontSize: '1.4rem',
                    border: 'none',
                    boxShadow: 'none',
                    outline: 'none',
                  }}
                  type="text"
                  placeholder="Suchbegriff eingeben"
                  value={searchfield}
                  onChange={(e) => setSearchfield(e.target.value)}
                />
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      {/* --------------------------------------- */}
      {/* DETAILMODAL */}
      {/* --------------------------------------- */}
      <Modal size="lg" show={ModalTable} onHide={() => setModalTable(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Detailanzeige zu Vertragsnummer {vertrag}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {TableDaten && TableDaten.length > 0 ? (
              <Col xs={12}>
                <Table striped responsive bordered hover>
                  <thead>
                    <tr>
                      <th>Kundennummer</th>
                      <th>Anrede</th>
                      <th>Name</th>
                      <th>Vorname</th>
                      <th>Gebäude</th>
                      <th>Kommission 1</th>
                      <th>Kommission 2</th>
                      <th>Status Vertrag</th>
                      <th>Gebäude-Komplex</th>
                      <th>Winter/Sommer</th>
                      <th>Kompetenzstufe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {TableDaten.map((v, index) => (
                      <tr key={index}>
                        <td>{v.KundeKundenNr}</td>
                        <td>{v.KundeAnrede}</td>
                        <td>{v.KundeName1}</td>
                        <td>{v.KundeName2}</td>
                        <td>{v.WAV_Gebaeude}</td>
                        <td>{v.WAV_Kommission1}</td>
                        <td>{v.WAV_Kommission2}</td>
                        <td>{v.WAV_AktivPassivStatus}</td>
                        <td>{v.WAV_GeabeudeKomplex}</td>
                        <td>{v.Zeit}</td>
                        <td>{v.Art}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            ) : (
              <Col xs={12} className="text-center">
                <h3>Es sind keine weiteren Details verfügbar</h3>
              </Col>
            )}
          </Row>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default Schluesselliste;
